/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { StickyBar, theme, FlexContainer } from "@nordcloud/gnui";
import { TRANSITION } from "~/constants";
import { ButtonWrap } from "./ButtonWrap";

type Props = React.ComponentPropsWithoutRef<typeof StickyBar> & {
  children: React.ReactNode;
  buttonContent?: React.ReactNode;
  onClose: () => void;
};

export function TopBar({
  children,
  buttonContent = "Close",
  onClose,
  ...rest
}: Props) {
  return (
    <StickyBar {...rest}>
      {children}
      <FlexContainer>
        <ButtonWrap
          css={{
            cursor: "pointer",
            transition: `opacity ${TRANSITION.default}`,
            marginLeft: theme.spacing.spacing03,
            fontWeight: theme.typography.fontWeights[1],
            lineHeight: 1,

            "&:hover": {
              opacity: 0.6,
              textDecoration: "underline",
            },
          }}
          onClick={onClose}
        >
          {buttonContent}
        </ButtonWrap>
      </FlexContainer>
    </StickyBar>
  );
}
